// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c3fdb048","238":"a9b81939","239":"5af9701a","453":"c1444e14","455":"9ccf48c0","557":"420bfbe6","762":"5d544c27"}[chunkId] + ".chunk.js";
};